import { isHaveBadWords } from "../../../../helpers/badWords"

const validation = (value) => {
  if (value.length === 0 && value[0] === undefined) return ""
  if (isHaveBadWords(value)) return "Please don't use bad language"
  if (value.length > 64)
    return "Please enter a correct other job title that consists of no more than 64 characters"
  if (value.trim().length < 8 || value.trim().length === 0)
    return "Please enter a correct other job title that consists of a minimum 8 characters"
}

export default validation
